<template>
  <div
    class="vx-card flex justify-center items-center flex-col relative"
    style="min-height: 420px"
  >
    <h5 class="w-full absolute p-4 text-lg z-10" style="top: 10px; right: 10px">
      موجودی بر اساس سگمنت
    </h5>
    <div class="w-full h-full relative">
      <vue-apex-charts
        v-if="showChart"
        type="bar"
        height="400px"
        class="absolute w-full bottom-0"
        :options="chartOptions"
        :series="series"
      />
      <Shimmer v-else class="w-full h-full"></Shimmer>
    </div>
  </div>
</template>

<script>
import Shimmer from "@/components/Shimmer.vue";
import VueApexCharts from "vue-apexcharts";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      showChart: false,
      series: [],
      chartOptions: {
        plotOptions: {
          bar: {
            borderRadius: 1,
          },
        },
        yaxis: {
          labels: {
            offsetX: -10,
          },
        },
        xaxis: {
          labels: {
            rotateAlways: true,
            style: {
              cssClass: "no-hover",
            },
            offsetY: 28,
            offsetX: -17,
          },
        },
        labels: [],
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        colors: ["#008FFB", "#00E396"],
        chart: {
          type: "bar",
          toolbar: {
            show: false,
          },
          offsetY: 60,
          offsetX: -25,
        },
        stroke: {
          width: 5,
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return `
              <div class="pb-2 arrow_box flex flex-col gap-2">
                <span class="apexcharts-tooltip-title px-2 flex items-center justify-center">
                  ${w.globals.labels[dataPointIndex]}
                </span>
                <div class="flex flex-col gap-1 px-2">
                  <div class="flex gap-2 items-center">
                    <div class="w-3 h-3 rounded-full" style="background-color: ${w.globals.colors[seriesIndex]}"></div>
                    <span>
                      ${w.globals.seriesNames[seriesIndex]}:
                    </span>
                    <span style="direction: ltr !important" class='font-bold'>
                      ${series[seriesIndex][dataPointIndex]}
                    </span>
                  </div>

                </div>
              </div>
            `;
          },
        },
      },
    };
  },
  methods: {
    ...mapActions({
      fetchInventoryBalanceChartData: "reports/fetchInventoryBalanceChartData",
    }),
    setColumnWidthBasedOnSeriesLength(seriesLength) {
      this.chartOptions.plotOptions.bar.columnWidth =
        20 + 60 / (1 + Math.exp(-1.2 * (seriesLength - 5.5))) + "%";
    },
  },
  mounted() {
    this.fetchInventoryBalanceChartData().then((response) => {
      let labels = [];
      let datasets = [
        { data: [], name: "موجودی فیزیکی" },
        { data: [], name: "موجودی منطقی" },
      ];
      response.forEach((segment) => {
        labels.push(segment.segmentName);
        datasets[0].data.push(segment.physicalBalance);
        datasets[1].data.push(segment.logicalBalance);
      });
      if (labels.length == 1) {
        labels.push("");
        labels.push("");
      }
      this.chartOptions.labels = labels;
      this.setColumnWidthBasedOnSeriesLength(labels.length);
      this.series = datasets;
      this.showChart = true;
    });
  },
  components: {
    Shimmer,
    VueApexCharts,
  },
};
</script>

<style scoped></style>
